/**
 * Seletor global de marca da sessão STAFF (Família A — furos F-484/F-487/F-491).
 *
 * Visível apenas para a casa: o staff assume aqui a marca de trabalho UMA vez
 * e as telas de produção leem de `useMarcaAssumida` como fallback. Para tenant
 * o componente não renderiza nada — a marca vem do client_id da sessão.
 */
import { useQuery } from '@tanstack/react-query';

import { destinationsApi } from '@/services/config';
import { usePlatformAccess } from '@/services/platform';
import { useMarcaAssumida } from '@/store/useMarcaAssumida';

export function SeletorMarca() {
  const { isStaff } = usePlatformAccess();
  const slug = useMarcaAssumida((s) => s.slug);
  const setSlug = useMarcaAssumida((s) => s.setSlug);
  const { data: sites } = useQuery({
    queryKey: ['wp-sites', 'active'],
    queryFn: () => destinationsApi.list(),
    staleTime: 5 * 60_000,
    enabled: isStaff,
  });

  if (!isStaff) return null;

  return (
    <select
      value={slug ?? ''}
      onChange={(e) => setSlug(e.target.value || null)}
      aria-label="Marca assumida (staff)"
      title="Marca de trabalho da sessão da casa — as telas de produção usam esta marca"
      style={{
        maxWidth: 160,
        fontSize: 12,
        padding: '4px 6px',
        borderRadius: 6,
        background: 'transparent',
        color: 'inherit',
        border: '1px solid currentcolor',
        opacity: slug ? 1 : 0.7,
      }}
    >
      <option value="">Marca: nenhuma</option>
      {(sites ?? []).map((s: { slug: string; name: string }) => (
        <option key={s.slug} value={s.slug}>
          {s.name}
        </option>
      ))}
    </select>
  );
}
